import PillLoadingBox from 'LuxKit/Pill/PillLoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'

function PriceRowValueDiscountWithCaptionLoadingSkeleton() {
  return <Group direction="horizontal" gap={4} verticalAlign="center">
    <TextLoadingBox typography="caption-medium" width="12ch" inline />
    <PillLoadingBox width={48} />
  </Group>
}

export default PriceRowValueDiscountWithCaptionLoadingSkeleton
